interface FeefoReview
{
  customer: {
    display_name: string | null;
  } | null;
  service: {
    rating: {
      rating: number;
    };
    review: string;
    created_at: string;
  };
}

interface FeefoResponse
{
  reviews: FeefoReview[];
  summary: {
    meta: {
      pages: number;
      current_page: number;
    };
  };
}

(function ()
{
  const loadMoreButton = document.getElementById("js-load-more");

  if (loadMoreButton)
  {
    loadMoreButton.addEventListener("click", function ()
    {
      const num = parseInt(this.dataset.page as string, 10);
      fetchFeefoReviews(num);
    });
  }
  fetchFeefoReviews(1);
})();

function fetchFeefoReviews(pageNum: number): void
{
  const request = `https://api.feefo.com/api/20/reviews/all?merchant_identifier=ms-self-storage&page_size=15&page=${pageNum}`;

  fetch(request)
    .then((response) =>
    {
      if (!response.ok)
      {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data: FeefoResponse) =>
    {
      processFeefoReviews(data);
      updateLoadMoreButton(data.summary.meta.pages, data.summary.meta.current_page);
    })
    .catch((error) =>
    {
      console.error("There has been a problem with your fetch operation:", error);
    });
}

function processFeefoReviews(data: FeefoResponse): void
{
  const reviewBlock = document.getElementById("js-reviews");

  if (!reviewBlock) return;

  data.reviews.forEach((review) =>
  {
    const { customer, service } = review;

    // Outer/Inner Wrappers
    const masonryItem = document.createElement("div");
    masonryItem.classList.add("masonry-item", "curved-edges", "drop-shadow", "bg-white");

    const innerDiv = document.createElement("div");
    innerDiv.classList.add("d-flex", "flex-column", "justify-content-between", "p-4", "mb-4");

    // Stars
    const starDiv = document.createElement("div");
    starDiv.classList.add("stars", "pb-1");

    for (let j = 1; j <= 5; j++)
    {
      const star = document.createElement("span");
      star.classList.add(j <= service.rating.rating ? "star-on" : "star-off");
      star.innerHTML = "&starf;";
      starDiv.appendChild(star);
    }

    // Quote
    const quoteDiv = document.createElement("div");
    quoteDiv.classList.add("quote", "pb-2");
    quoteDiv.textContent = service.review;

    // Details
    const nameDiv = document.createElement("div");
    nameDiv.classList.add("name");

    const dt = formatDate(service.created_at);
    const details = customer?.display_name ? `- ${customer.display_name}, ${dt}` : `- ${dt}`;
    nameDiv.textContent = details;

    // Append elements
    innerDiv.appendChild(starDiv);
    innerDiv.appendChild(quoteDiv);
    innerDiv.appendChild(nameDiv);
    masonryItem.appendChild(innerDiv);
    reviewBlock.appendChild(masonryItem);
  });
}

function formatDate(dt: string): string
{
  const date = new Date(dt);
  return date.toLocaleDateString("en-UK", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

function updateLoadMoreButton(maxPage: number, curPage: number): void
{
  const btn = document.getElementById("js-load-more");

  if (!btn) return;

  const nextPage = curPage + 1;
  if (nextPage > maxPage)
  {
    btn.classList.add("d-none");
  } else
  {
    btn.dataset.page = nextPage.toString();
  }
}
